import React from 'react'

function RetreatsPage() {
  return (
    <div>RetreatsPage</div>
  )
}

export default RetreatsPage